import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { ConnectionHealth } from '../types'

/**
 * Monitor database connection health
 */
export function useConnectionHealth() {
    return useQuery<ConnectionHealth>({
        queryKey: ['social-connection-health'],
        queryFn: async () => {
            try {
                const start = performance.now()
                const { error } = await supabase
                    .from('social_profiles')
                    .select('id')
                    .limit(1)
                const end = performance.now()

                if (error) throw error

                return {
                    status: 'healthy',
                    latency: Math.round(end - start)
                }
            } catch (error: any) {
                return {
                    status: 'unhealthy',
                    message: error.message || 'Connection failed'
                }
            }
        },
        refetchInterval: 30000 // Check every 30 seconds
    })
}
